import { OrganizationDao } from "./OrganizationDao";
import { useMemo } from "react";
import { useAccessToken } from "shared-ts-utils-authentication";

export const useOrganizationDao = (): OrganizationDao => {
  const accessToken = useAccessToken();
  return useMemo(
    () =>
      new OrganizationDao({
        accessToken: accessToken,
      }),
    [accessToken]
  );
};
